import { PropsWithChildren, useRef } from 'react';
import { observer } from 'mobx-react';
import { EnterpriseUserToken } from '@enterprise/common';
import { Header } from '../header';
import { useStores } from '../../../hooks';

export const MainLayout = observer(function MainLayoutComponent({ children }: PropsWithChildren) {
    const {
        ui: { app },
    } = useStores();

    const scrollContainerElement = useRef<HTMLDivElement>(null);

    const logout = () => {
        app.logout();
    };

    const menuItems = app.getAvailableMenuItems();

    let orgName = '';
    if ((app.token as EnterpriseUserToken).user.organization) {
        orgName = (app.token as EnterpriseUserToken).user.organization.name;
    }

    return (
        <div className="main-layout">
            <Header
                navigation={menuItems}
                user={{
                    username: app.token.getDisplayName(),
                    orgName,
                    avatar: app.token?.user?.profile?.avatar,
                }}
                onLogout={logout}
            />
            <div className="main">
                <div id="connect-page-content" className="connect-page-content" ref={scrollContainerElement}>
                    <div id="scroll-to-here" />
                    {children}
                </div>
            </div>
        </div>
    );
});
